// Fixing wave issues
document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(".mega-menu-promotion--link");

  links.forEach(link => {
    // Check if link is empty (no visible text or content)
    const isEmpty =
      !link.textContent.trim() &&
      link.children.length === 0;

    if (isEmpty) {
      link.setAttribute("role", "presentation");
      link.setAttribute("aria-hidden", "true");
      link.setAttribute("tabindex");
    }
  });
});

// Removing heading
document.addEventListener("DOMContentLoaded", () => {
  const headings = document.querySelectorAll("h5, h6");

  headings.forEach(el => {
    if (!el.textContent.trim()) {
      el.remove();
    }
  });
});

// Announcement bar
document.addEventListener('DOMContentLoaded', function () {
  function makeAnnouncementBarAccessible() {
    const announcementBars = document.querySelectorAll('.announcement-bar');

    announcementBars.forEach(function (bar, barIndex) {
      const carousel = bar.querySelector('slide-show.announcement-bar--carousel, slide-show.carousel');
      const slides = Array.from(bar.querySelectorAll('.announcement-bar--item.carousel__slide'));
      const prevControl = bar.querySelector('.flickity-prev');
      const nextControl = bar.querySelector('.flickity-next');

      if (!carousel || !slides.length) return;

      const regionLabel = 'Announcement bar';
      const statusId = 'announcement-bar-status-' + barIndex;

      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', regionLabel);

      carousel.setAttribute('role', 'group');
      carousel.setAttribute('aria-roledescription', 'carousel');
      carousel.setAttribute('aria-label', 'Store announcements');
      carousel.removeAttribute('tabindex');

      let status = bar.querySelector('#' + statusId);

      if (!status) {
        status = document.createElement('p');
        status.id = statusId;
        status.className = 'visually-hidden announcement-bar-status';
        status.setAttribute('aria-live', 'polite');
        status.setAttribute('aria-atomic', 'true');
        bar.appendChild(status);
      }

      function setupArrow(control, label) {
        if (!control) return;

        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
        control.setAttribute('aria-label', label);

        const svg = control.querySelector('svg');
        if (svg) {
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('focusable', 'false');
        }

        control.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            control.click();
          }
        });
      }

      setupArrow(prevControl, 'Previous announcement');
      setupArrow(nextControl, 'Next announcement');

      function updateSlides() {
        let selectedIndex = 0;

        slides.forEach(function (slide, index) {
          const isSelected = slide.classList.contains('is-selected');

          if (isSelected) {
            selectedIndex = index;
          }

          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', 'Announcement ' + (index + 1) + ' of ' + slides.length);
          slide.setAttribute('aria-hidden', isSelected ? 'false' : 'true');

          const focusableItems = slide.querySelectorAll(
            'a, button, input, select, textarea, [tabindex]'
          );

          focusableItems.forEach(function (item) {
            if (isSelected) {
              item.removeAttribute('tabindex');
            } else {
              item.setAttribute('tabindex');
            }
          });
        });

        const selectedSlide = slides[selectedIndex];
        const selectedText = selectedSlide
          ? selectedSlide.textContent.replace(/\s+/g, ' ').trim()
          : '';

        status.textContent =
          'Showing announcement ' +
          (selectedIndex + 1) +
          ' of ' +
          slides.length +
          '. ' +
          selectedText;
      }

      slides.forEach(function (slide) {
        const links = slide.querySelectorAll('');

        links.forEach(function (link) {
          const currentLabel =
            link.getAttribute('aria-label') ||
            link.textContent.replace(/\s+/g, ' ').trim() ||
            'Link';

          if (!currentLabel.toLowerCase().includes('')) {
            link.setAttribute('aria-label', currentLabel);
          }

          link.setAttribute('rel', 'noopener noreferrer');
        });
      });

      updateSlides();

      const observer = new MutationObserver(function () {
        updateSlides();
      });

      slides.forEach(function (slide) {
        observer.observe(slide, {
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      });
    });
  }

  makeAnnouncementBarAccessible();

  document.addEventListener('shopify:section:load', function () {
    makeAnnouncementBarAccessible();
  });
});

// Accessible Menu
document.addEventListener("DOMContentLoaded", function () {
  const menu = document.querySelector("full-menu .thb-full-menu");

  if (!menu) return;

  const parentItems = menu.querySelectorAll(".menu-item-has-children");

  function getFocusable(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])'
      )
    ).filter(function (el) {
      return el.offsetParent !== null;
    });
  }

  function preparePromotionLinks(submenu) {
    const promoLinks = submenu.querySelectorAll(".mega-menu-promotion--link");

    promoLinks.forEach(function (link) {
      link.setAttribute("role", "presentation");
      link.setAttribute("aria-hidden", "true");

      /*
        Removing href because these promotional links are decorative/presentational.
        If any promotion should remain clickable, remove this part.
      */
      if (link.hasAttribute("href")) {
        link.setAttribute("data-original-href", link.getAttribute("href"));
        link.removeAttribute("href");
      }
    });
  }

  function closeMenu(parentItem, returnFocus) {
    const trigger = parentItem.querySelector(":scope > a");
    const submenu = parentItem.querySelector(":scope > .sub-menu");

    if (!trigger || !submenu) return;

    parentItem.classList.remove("is-open");
    parentItem.classList.remove("active");

    trigger.setAttribute("aria-expanded", "false");

    submenu.setAttribute("aria-hidden", "true");

    if (returnFocus) {
      trigger.focus();
    }
  }

  function closeAllMenus(exceptItem) {
    parentItems.forEach(function (item) {
      if (item !== exceptItem) {
        closeMenu(item, false);
      }
    });
  }

  function openMenu(parentItem) {
    const trigger = parentItem.querySelector(":scope > a");
    const submenu = parentItem.querySelector(":scope > .sub-menu");

    if (!trigger || !submenu) return;

    closeAllMenus(parentItem);

    parentItem.classList.add("is-open");
    parentItem.classList.add("active");

    trigger.setAttribute("aria-expanded", "true");
    submenu.setAttribute("aria-hidden", "false");
  }

  function toggleMenu(parentItem) {
    const trigger = parentItem.querySelector(":scope > a");

    if (!trigger) return;

    const isOpen = trigger.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      closeMenu(parentItem, true);
    } else {
      openMenu(parentItem);
    }
  }

  parentItems.forEach(function (parentItem, index) {
    const trigger = parentItem.querySelector(":scope > a");
    const submenu = parentItem.querySelector(":scope > .sub-menu");

    if (!trigger || !submenu) return;

    if (!submenu.id) {
      submenu.id = "accessible-submenu-" + index;
    }

    /*
      Remove href from parent dropdown items only.
      These parent items now behave like buttons that open/close the submenu.
    */
    if (trigger.hasAttribute("href")) {
      trigger.setAttribute("data-original-href", trigger.getAttribute("href"));
      trigger.removeAttribute("href");
    }

    trigger.setAttribute("role", "button");
    trigger.setAttribute("tabindex", "0");
    trigger.setAttribute("aria-haspopup", "true");
    trigger.setAttribute("aria-expanded", "false");
    trigger.setAttribute("aria-controls", submenu.id);

    submenu.setAttribute("aria-hidden", "true");

    preparePromotionLinks(submenu);

    /*
      Stop hover-based behavior from opening the menu.
      The menu should open by click, Enter, Space, or ArrowDown.
    */
    parentItem.addEventListener(
      "mouseenter",
      function () {
        if (!parentItem.classList.contains("is-open")) {
          parentItem.classList.remove("active");
        }
      },
      true
    );

    parentItem.addEventListener(
      "mouseover",
      function () {
        if (!parentItem.classList.contains("is-open")) {
          parentItem.classList.remove("active");
        }
      },
      true
    );

    parentItem.addEventListener(
      "mouseleave",
      function () {
        if (!parentItem.classList.contains("is-open")) {
          parentItem.classList.remove("active");
        }
      },
      true
    );

    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      toggleMenu(parentItem);
    });

    trigger.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        toggleMenu(parentItem);
      }

      if (event.key === "Escape") {
        event.preventDefault();
        closeMenu(parentItem, true);
      }

      if (event.key === "ArrowDown") {
        event.preventDefault();
        openMenu(parentItem);

        const firstFocusable = getFocusable(submenu)[0];

        if (firstFocusable) {
          firstFocusable.focus();
        }
      }
    });

    submenu.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        event.preventDefault();
        closeMenu(parentItem, true);
      }
    });

    parentItem.addEventListener("focusout", function () {
      setTimeout(function () {
        if (!parentItem.contains(document.activeElement)) {
          closeMenu(parentItem, false);
        }
      }, 80);
    });
  });

  document.addEventListener("click", function (event) {
    if (!menu.contains(event.target)) {
      closeAllMenus();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      const openItem = menu.querySelector(".menu-item-has-children.is-open");

      if (openItem) {
        event.preventDefault();
        closeMenu(openItem, true);
      }
    }
  });
});

// External links Warning 
document.addEventListener("DOMContentLoaded", function () {
  const excludedLinks = [
    'https://www.facebook.com/RosadosBox.LovePromiseJewelers/',
    'https://twitter.com/rosadosbox',
    'https://instagram.com/rosadosbox/',
    'https://www.pinterest.com/rosadosbox/',
    'https://www.youtube.com/channel/UCTAL_uAbH5dPN1cLxD9bJxQ/videos',
    'https://www.tiktok.com/@rosadosbox?lang=en',
  ];

  const normalizeHost = (host) => host.replace(/^www\./, '');

  const isExternalLink = (url) => {
    try {
      const linkUrl = new URL(url, window.location.origin); // handles relative URLs
      const linkHost = normalizeHost(linkUrl.hostname);
      const currentHost = normalizeHost(window.location.hostname);

      return linkHost && linkHost !== currentHost;
    } catch {
      return false;
    }
  };

  const enhanceExternalLinks = () => {
    const links = document.querySelectorAll('a');

    links.forEach(link => {
      const href = link.getAttribute('href');

      if (
        !href ||
        excludedLinks.includes(href) ||
        link.matches('li[data-submenu-parent] > a') ||
        !isExternalLink(href)
      ) return;

      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

      const linkText = link.textContent.trim();

      if (!link.hasAttribute('aria-label')) {
        link.setAttribute(
          'aria-label',
          `${linkText}, Redirecting to a third-party website (opens in a new tab).`
        );
      }

      const img = link.querySelector('img, svg');
      if (img) {
        const altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, Redirecting to a third-party website (opens in a new tab).`
          : 'Redirecting to a third-party website (opens in a new tab).';

        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  const enhanceContactLinks = () => {
    const contactLinks = document.querySelectorAll(
      'a[href^="mailto:"], a[href^="tel:"]'
    );

    contactLinks.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };

  enhanceExternalLinks();
  enhanceContactLinks();
});

// back to top
document.addEventListener("DOMContentLoaded", function () {
  const backToTopBtn = document.querySelector("#backtotop");
  const topBackDiv = document.querySelector("div#top-back");

  if (backToTopBtn && topBackDiv) {
    backToTopBtn.addEventListener("click", function () {
      setTimeout(function () {
        topBackDiv.setAttribute("tabindex", "-1");
        topBackDiv.focus();
      }, 500); 
    });
  }
});

// aria-label for mini and maxi
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const lowerHandle = document.querySelector(".noUi-handle.noUi-handle-lower");
    const upperHandle = document.querySelector(".noUi-handle.noUi-handle-upper");

    if (lowerHandle) {
      lowerHandle.setAttribute("aria-label", "Minimum");
    }

    if (upperHandle) {
      upperHandle.setAttribute("aria-label", "Maximum");
    }
  }, 1000); // 1 second delay
});

// focus size guide
document.addEventListener("DOMContentLoaded", function () {
  const closeButton = document.querySelector("div#Size-Drawer .side-panel-close");
  const toggleButton = document.querySelector("button#size-drawer-toggle");

  if (closeButton && toggleButton) {
    closeButton.addEventListener("click", function () {
      setTimeout(function () {
        toggleButton.focus();
      }, 1000); // 1 second delay
    });
  }
});

// add to cart focus
document.addEventListener("DOMContentLoaded", function () {
  const addToCartButton = document.querySelector("button#AddToCart");
  const cartDrawer = document.querySelector("div#Cart-Drawer");

  if (addToCartButton && cartDrawer) {
    addToCartButton.addEventListener("click", function () {
      setTimeout(function () {
        cartDrawer.setAttribute("tabindex", "-1");
        cartDrawer.focus();
      }, 1000); 
    });
  }
});